@import 'styles/mixins';
@import 'styles/blaze/mixins';

.blogPostChromeContainer {
  position: absolute;
  width: 100%;
  z-index: 1;

  .tabContainer {
    height: 42px;
    border-radius: 20px 20px 0 0;
    background: var(--dark-4);
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-left: 13px;
    gap: 15px;

    .circles {
      display: flex;
      align-items: center;
      gap: 8px;

      .littleCircle {
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background: var(--dark-8);
        border: 1px solid var(--dark-15);
      }
    }

    .tab {
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
      align-self: self-end;
    }

    .tabContent {
      padding: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      background: var(--light-100);
      color: var(--dark-80);
      border-radius: 8px 8px 0 0;
      height: 34px;
      font-family: Roboto;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      letter-spacing: 0.2px;
    }
  }

  .urlContainer {
    background: var(--light-100);
    box-shadow: 0 -1px 0 0 #dadce0 inset;
    height: 38px;
    padding: 5px 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;

    .url {
      border-radius: 14px;
      height: 28px;
      background: var(--dark-4);
      width: 100%;
      padding: 8px 11px;
      display: flex;
      align-items: center;
      gap: 10px;

      .text {
        color: var(--dark-80);
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        letter-spacing: 0.25px;
      }

      svg {
        fill: var(--dark-60);

        path {
          stroke: transparent;
        }
      }
    }

    .circle {
      width: 22px;
      height: 22px;
      border-radius: 50%;
      background: var(--dark-4);
    }
  }
}
